import React from 'react'
import { 
  Box, 
  Stack, 
  styled, 
  Typography,
} from '@mui/material'
import Link from '@mui/material/Link';
import FooterTitle from './FooterTitle'
import FooterLink from './FooterLink'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {

  const StackColumn = styled(Stack) (() => ({
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
    gap: 8,
    textAlign: 'center',
  }));

  const BoxRow = styled(Box) (({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#ededed',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 30,
    }
  }));

  return (
    
    <BoxRow 
    component = 'footer'
    sx={{
      py: 4,
      px: 2,
    }}
    >
      <StackColumn>
        <FooterTitle text={'address'} />
        <FooterLink 
        text={'Palladam - Cochin Frontier Road '} 
        />
        <FooterLink 
        text={'Chettipalayam, Tamil Nadu 641201'} 
        />
          <FooterLink 
        text={' '} 
        />
        <FooterLink 
        text={'ContactNumber: 7639568608'} 
        />
          <FooterLink 
        text={' '} 
        />
         <FooterLink 
        text={'perumalcraneservices@gmail.com'} 
        />
      </StackColumn>
      
      <StackColumn>
        <FooterTitle text={'Industries Served'} />
        <FooterLink text={'Construction'} />
        <FooterLink text={'Infrastructure Development'} />
        <FooterLink text={'Renewable Energy'} />
        <FooterLink text={'Shipbuilding'} />
        <FooterLink text={'And more'} />
      </StackColumn>
     

      <StackColumn>
        <FooterTitle text={'Perumal Crane Service'} />
        <Stack 
        direction='row' 
        width= '70px'
        maxWidth='100%'
        justifyContent='space-between'
        >
          <Link href="https://www.instagram.com/perumal_crane_services_1/" variant="body2" 
      sx={{
        color: '#414141',
        "&:hover": {
          color: '#1c2859',
        }
      }}
>
  <InstagramIcon />  
</Link> 

          <Link href="https://www.facebook.com/p/Sri-Perumal-Crane-Services-100069455018192/?locale=en"variant="body2" 
          sx={{
            color: '#414141',
            "&:hover": {
              color: '#1c2859',
            }
          }}
          >
            <FacebookIcon />
          </Link> 
        </Stack>
        <Typography 
        variant='caption'
        component='p' 
        >
          &copy; Perumal Crane Service.
        </Typography>
      </StackColumn>
    </BoxRow>
  )
}

export default Footer